import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginPageUrl } from '../url/poenUrl';

const LoginRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const permissions = localStorage.getItem('permissions');
    const accessToken = localStorage.getItem('accessToken');

    if (!permissions || !accessToken) {
      localStorage.clear();
      sessionStorage.clear();

      // 모든 쿠키 삭제
      document.cookie.split(';').forEach((cookie) => {
        const [name] = cookie.split('=');
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });
      navigate(LoginPageUrl); // 기타 사용자 -> StuffPage로 이동
    }
  }, [navigate]);

  return null; // 이 컴포넌트는 UI를 렌더링하지 않음
};

export default LoginRedirect;
